import React from 'react';

import { Construction } from 'lucide-react';

import PageHeader, { BreadcrumbConfig } from './PageHeader';
import PageShell from './PageShell';

interface UnderConstructionProps {
  title: string;
  breadcrumbs: BreadcrumbConfig[];
}

const UnderConstruction: React.FC<UnderConstructionProps> = ({
  title,
  breadcrumbs,
}) => {
  return (
    <PageShell header={<PageHeader title={title} breadcrumbs={breadcrumbs} />}>
      <div className="flex h-full min-h-[50vh] items-center justify-center">
        <div className="w-full max-w-xl rounded-2xl border border-neutral-200 bg-white p-8 text-center shadow-sm dark:border-neutral-800 dark:bg-neutral-950">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-50 text-brand-600 dark:bg-brand-950 dark:text-brand-300">
            <Construction className="h-6 w-6" />
          </div>
          <p className="text-base font-medium text-neutral-900 dark:text-white">
            This module is being prepared. Please check back later.
          </p>
        </div>
      </div>
    </PageShell>
  );
};

export default UnderConstruction;
